// ForgotPasswordScreen.js
import React, { useState } from "react";
import axios from "axios"; // or your axiosInstance

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post("/api/users/forgot-password", {
        email,
      });
      setMessage(data.message);
    } catch (error) {
      setMessage(error.response?.data?.message || error.message);
    }
  };

  return (
    <div>
      <h2>Forgot Password</h2>
      <p>Enter your email address. We’ll send a reset link if it exists.</p>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit">Send Reset Link</button>
      </form>
      {message && <div>{message}</div>}
    </div>
  );
};

export default ForgotPasswordScreen;
